interface ContentfulItem {
    id: string;
    title?: string | null;
    name?: string | null;
    description?: string | null;
}

export function saveContentfulItems(name: string, items: ContentfulItem[]) {
    const saveItems = (
        config:
            | {
                  environment: string;
                  spaceId: string;
                  apiKey?: string;
              }
            | undefined,
        items: {
            id: string;
            title?: string | null;
            name?: string | null;
            description?: string | null;
        }[],
    ) => {
        const listItems = items.map((item) => ({
            id: item.id,
            title: item.title || item.name || item.description,
        }));

        if (config) {
            const { apiKey: _apiKey, ...configWithoutApiKey } = config;

            document.cookie = `contentful_config=${encodeURIComponent(JSON.stringify(configWithoutApiKey))}; path=/; max-age=86400`;
            document.cookie = `${name}=${encodeURIComponent(JSON.stringify(listItems))}; path=/; max-age=86400`;

            localStorage.setItem("contentful_config", JSON.stringify(config));
            localStorage.setItem(name, JSON.stringify(listItems));
        }
    };

    if (window.CONTENTFUL_CONFIG) {
        saveItems(window.CONTENTFUL_CONFIG, items);
    }
}
